import { RuleId } from '@wix/a11y-rules';
import { ITEM_TYPES } from '@wix/advanced-seo-utils';
import { assertNotOptional } from '@wix/seo-common-core';
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { usePanelStateAtom } from '../../../../../hooks/rules-state/use-panel-state-atom';
import { useBaseAltTextRuleHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-base-alt-text-rule-handlers';
import { useStaticPagesAltTextHandlers } from '../../../../../rule-mappers/rule-handlers/alt-text-v2/use-static-pages-alt-text-handlers';
import { useGetAltTextHandlersFromItemType } from '../hooks/use-get-alt-text-handlers-from-item-type';
import { AltTextScreen } from './alt-text-screen';
import { useAltTextScreen } from './use-alt-text-screen';
export const AltTextScreenContext = /*#__PURE__*/createContext(undefined);
export const AltTextScreenWrapper = _ref => {
  var _pagesData$get;
  let {
    pageId,
    itemType
  } = _ref;
  const {
    getGroupData,
    panelState,
    getPagesData
  } = usePanelStateAtom();
  const pagesData = getPagesData();
  const getAltTextScreenData = useCallback(() => {
    if (itemType === ITEM_TYPES.STATIC_PAGE_V2) {
      var _getGroupData;
      return (_getGroupData = getGroupData(pageId)) == null || (_getGroupData = _getGroupData.ruleExecutionResults) == null ? void 0 : _getGroupData.filter(result => result.ruleId === RuleId.STATIC_ALT_TEXT);
    }
    return Array.from(panelState.groupsDataMap.entries()).filter(_ref2 => {
      let [_, groupData] = _ref2;
      return groupData.itemType === itemType;
    }).flatMap(_ref3 => {
      var _groupData$ruleExecut;
      let [_, groupData] = _ref3;
      return (_groupData$ruleExecut = groupData.ruleExecutionResults) == null ? void 0 : _groupData$ruleExecut.filter(result => result.ruleId === RuleId.STATIC_ALT_TEXT);
    });
  }, [getGroupData, itemType, pageId, panelState.groupsDataMap]);
  const pageResult = useMemo(() => getAltTextScreenData(), [getAltTextScreenData]);
  const altHandlers = useGetAltTextHandlersFromItemType({
    itemType
  });
  const staticAltHandlers = useStaticPagesAltTextHandlers();
  const baseAltHandlers = useBaseAltTextRuleHandlers();
  assertNotOptional(pageResult, 'pageResult');
  assertNotOptional(altHandlers, 'altHandlers');
  const altImageProps = useMemo(() => baseAltHandlers.extractAltImageProps(pageResult, pageId), [baseAltHandlers, pageId, pageResult]);
  const initialAltRulesProps = useMemo(() => altHandlers != null && altHandlers.getElementOrder ? altHandlers.getElementOrder(altImageProps) : altImageProps, [altHandlers, altImageProps]);
  const [altRulesProps, setAltRulesProps] = useState(initialAltRulesProps);
  const pageName = (_pagesData$get = pagesData.get(pageId)) == null ? void 0 : _pagesData$get.title;
  assertNotOptional(pageName, 'pageName');
  const altTextScreenContextValue = {
    ...useAltTextScreen({
      altHandlers,
      altRulesProps,
      itemType,
      pageId,
      pageName,
      setAltRulesProps,
      staticAltHandlers
    })
  };
  return /*#__PURE__*/React.createElement(AltTextScreenContext.Provider, {
    value: altTextScreenContextValue
  }, /*#__PURE__*/React.createElement(AltTextScreen, null));
};
export const useAltTextScreenContext = () => {
  const context = useContext(AltTextScreenContext);
  if (!context) {
    return {
      actions: {},
      state: {}
    };
  }
  return context;
};
//# sourceMappingURL=alt-text-screen-wrapper.js.map